.shipped {
  font-weight: 500;
  color: #212121;
}

.total {
  color: #212121;
}

.value {
  font-weight: 500;
}

.analyticsWrapper {
  display: flex;
  margin-top: 8px;
  line-height: 1.7rem;
}

.analytics {
  flex: 1 1 70%;
}

.card {
  margin: 10px;
  border-radius: 15px;
  box-shadow: 0 0 22px 2px rgba(0, 0, 0, 0.1);
  padding: 10px;
  background-color: white;
}

.debtCard {
  width: 100%;
  background-color: #f5f5f5;
  border-radius: 15px;
  border: 1px #e6e6e6 solid;
  margin-bottom: 15px;
  display: flex;
  padding: 15px 0;
}

.debtField {
  padding: 0 15px;
  width: 100%;
  border-right: 1px solid #e6e6e6;
  display: grid;
  align-items: center;
  align-content: space-between;
}

.debtField:last-child {
  border-right: 0;
}

.debtText {
  font-size: 0.9rem;
  font-weight: 500;
  color: #757575;
  margin-bottom: 5px;
}

.progress {
  display: flex;
  height: 15px;
  width: 100%;
  margin-top: 10px;
}

.progressLegend {
  display: flex;
  height: 15px;
  width: 100%;
  margin-bottom: 10px;
}

.progressBar {
  width: 100%;
  height: 15px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}

.progressPdz {
  background-color: #e21d48;
  border-radius: 10px;
}

.progressFact {
  width: 100%;
  height: 15px;
  background-color: #fbbf29;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}

.progressFree {
  height: 15px;
  background-color: #17a34a;
  border-radius: 10px;
}

.limit {
  font-weight: 500;
  color: #757575;
  padding: 10px 0;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.limitAmount {
  color: black;
  font-weight: 600;
  font-size: 14px;
}

.amounts {
  padding: 5px;
  font-weight: 500;
  color: #757575;
}

.amountsLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.amountSum {
  color: black;
  font-weight: 600;
  font-size: 14px;
}

.amountsDotFree {
  font-weight: 600;
  font-size: 1.2rem;
  color: #17a34a;
}

.amountsDotFact {
  font-weight: 600;
  font-size: 1.2rem;
  color: #fbbf29;
}

.amountsDotPdz {
  font-weight: 600;
  font-size: 1.2rem;
  color: #e21d48;
}
